import { observable } from "mobx";
import { Type } from "class-transformer";
import PaymentEditingPermittedActionResponse from "./paymentEditingPermittedActionResponse";
import RefundationPermittedActionResponse from "./refundationPermittedActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidatePermittedActionsResponse {
  @observable
  @Type(() => RefundationPermittedActionResponse)
  refundation!: RefundationPermittedActionResponse;

  @observable
  @Type(() => PaymentEditingPermittedActionResponse)
  paymentEditing!: PaymentEditingPermittedActionResponse;
}
